// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_settingsMenuList__a7m6T {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 30px 0;
}

.page_settingsListWrap__ajFRR {
    display: flex;
}

.page_navLeftList__oOYkY {
    max-width: 370px;
    min-width: 370px;
}

.page_settingsMenuBlockTitle__ePcZp {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--cloudburst);
}

.page_titleBottom__ZSzau {
    padding: 0 0 15px;
    margin-bottom: 0;
}

.page_navigationLeft__Vv-\\+V {
    min-width: 280px;
    background: var(--white);
    border-width: 1px;
    border-style: solid;
    border-color: var(--ashyblue);
    border-radius: 6px;
}

.page_navigationBlocks__sV4ol {
    border-bottom: 1px solid var(--lightgrey);
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0;
}

.page_navigationBlocks__sV4ol>div {
    overflow: hidden;
}

.page_pagesTitle__1OLzl {
    padding-right: 18px;
    padding-left: 18px;
    padding: 1rem 1.5rem;
    position: relative;
    cursor: pointer;
    margin: 0;
}

.page_pagesTitle__1OLzl::before {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right;
    background-repeat: no-repeat;
    width: 12px;
    height: 18px;
    display: block;
    left: auto;
    position: absolute;
    right: 20px;
    top: 20px;
    transform: rotate(270deg);
    transition: 0.3s;
}

.page_pagesTitle__1OLzl.page_active__uO7B2::before {
    transform: rotate(180deg);
}

.page_navigationTop__8IglY {
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 10px;
}

.page_pageSearchInput__\\+LKuJ {
    width: 100%;
    position: relative;
}

.page_pageSearchInput__\\+LKuJ input {
    width: calc(100% - 5px);
    height: 42px !important;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 5px 5px 6px 40px;
    outline: none;
    right: 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.page_pageSearchInput__\\+LKuJ input::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grey);
}

.page_pageSearchInput__\\+LKuJ img {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.page_settingsMenuPages__x0xMi {
    padding-right: 24px;
    padding-left: 24px;
    overflow: hidden;
}

.page_settingsMenuItem__hvWtz {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;
}

.page_settingsMenuItem__hvWtz input {
    margin-top: 2px;
    background: var(--white);
    -o-appearance: none;
    appearance: none;
    outline: none;
    border: none !important;
    cursor: pointer;
    width: 25px;
}

.page_settingsMenuItem__hvWtz label {
    flex: 1 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    cursor: pointer;
}

.page_removeItemBtn__IISeA {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    opacity: 0.6;
    transition: opacity 0.2s;
}

.page_removeItemBtn__IISeA:hover {
    opacity: 1;
}

.page_removeItemBtn__IISeA img {
    width: 16px;
    height: 16px;
}

.page_nothingFound__FI5Mc {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    margin-bottom: 10px;
}

.page_showMorePages__zaMsn {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
    opacity: 0.5;
    cursor: pointer;
}

.page_navigationRight__eplUk {
    margin-left: 35px;
    padding-top: 0;
    min-width: 300px;
}

.page_navRightList__\\+trVx {
    margin-top: 15px;
}

.page_menuSorter__bkNTq {
    min-height: 200px;
    position: relative;
}

.page_menuItemRow__GqFn0 {
    margin-bottom: 10px;
}

.page_menuItemRow__GqFn0.page_hidden__78hjc {
    opacity: 0.5;
}

.page_menuItem__DYlEl {
    display: flex;
    align-items: center;
    padding: 11.5px 14px;
    gap: 8px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    box-shadow: var(--boxshadow);
    border-radius: 6px;
    width: 100%;
    cursor: grab;
    font-size: 14px;
    transition: all 0.2s ease;
}

.page_menuItem__DYlEl:active {
    cursor: grabbing;
}

.page_dragIcon__lIVzV {
    cursor: grab;
    font-size: 16px;
    color: var(--cloudburst);
    opacity: 0.5;
}

.page_dragIcon__lIVzV:active {
    cursor: grabbing;
}

.page_menuTitleFront__ppNx5 {
    flex: 1 1;
    line-height: 18px;
    position: relative;
    top: 0px;
}

.page_placeholder__2TdDV {
    background: var(--whitesmoke);
    border: 1px dashed #d0d5dd;
    border-radius: 6px;
    margin-bottom: 10px;
    transition: all 0.2s ease;
}

.page_dragPreview__mTn3v {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1000;
    pointer-events: none;
}

.page_dragPreviewItem__j88LU {
    display: flex;
    align-items: center;
    padding: 11.5px 14px;
    gap: 8px;
    background: var(--white);
    border: 1px dashed #999;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.page_dragPreviewItemTitle__kUsq6 {
    flex: 1 1;
    line-height: 18px;
}

.page_saveButtons__xbG0q {
    display: flex;
    justify-content: flex-end;
    margin-block: 20px;
    padding-top: 20px;
    gap: 10px;
    border-top: 1px solid #d4d4d4;
}

.page_saveButton__hjObx {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    background-color: #000;
    border-color: transparent;
    padding: 8px 13px;
    text-align: center;
    width: 66px;
    height: 42px;
}

.page_saveButton__hjObx:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.page_ringLoader__YHdmS {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--cloudburst);
    border-radius: 50%;
    animation: page_spin__JeqAF 0.8s linear infinite;
    margin: 0 auto;
}

@keyframes page_spin__JeqAF {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive */
@media (max-width: 900px) {
    .page_settingsListWrap__ajFRR {
        flex-direction: column;
    }

    .page_navLeftList__oOYkY,
    .page_navigationRight__eplUk {
        max-width: 100%;
        min-width: auto;
    }

    .page_navigationRight__eplUk {
        margin-left: 0;
        margin-top: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/MobileMenu/page.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,yDAAmD;IACnD,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IAGxB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,gDAAoC;IACpC,cAAc;AAClB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ","sourcesContent":[".settingsMenuList {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 30px 30px 0;\n}\n\n.settingsListWrap {\n    display: flex;\n}\n\n.navLeftList {\n    max-width: 370px;\n    min-width: 370px;\n}\n\n.settingsMenuBlockTitle {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--cloudburst);\n}\n\n.titleBottom {\n    padding: 0 0 15px;\n    margin-bottom: 0;\n}\n\n.navigationLeft {\n    min-width: 280px;\n    background: var(--white);\n    border-width: 1px;\n    border-style: solid;\n    border-color: var(--ashyblue);\n    border-radius: 6px;\n}\n\n.navigationBlocks {\n    border-bottom: 1px solid var(--lightgrey);\n    width: 100%;\n    padding-top: 0px;\n    padding-bottom: 0;\n}\n\n.navigationBlocks>div {\n    overflow: hidden;\n}\n\n.pagesTitle {\n    padding-right: 18px;\n    padding-left: 18px;\n    padding: 1rem 1.5rem;\n    position: relative;\n    cursor: pointer;\n    margin: 0;\n}\n\n.pagesTitle::before {\n    content: \"\";\n    background-image: url(../../assets/images/down.svg);\n    background-position: right;\n    background-repeat: no-repeat;\n    width: 12px;\n    height: 18px;\n    display: block;\n    left: auto;\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    transform: rotate(270deg);\n    transition: 0.3s;\n}\n\n.pagesTitle.active::before {\n    transform: rotate(180deg);\n}\n\n.navigationTop {\n    padding-left: 18px;\n    padding-right: 18px;\n    padding-bottom: 10px;\n}\n\n.pageSearchInput {\n    width: 100%;\n    position: relative;\n}\n\n.pageSearchInput input {\n    width: calc(100% - 5px);\n    height: 42px !important;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 5px 5px 6px 40px;\n    outline: none;\n    right: 15px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.pageSearchInput input::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grey);\n}\n\n.pageSearchInput img {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.settingsMenuPages {\n    padding-right: 24px;\n    padding-left: 24px;\n    overflow: hidden;\n}\n\n.settingsMenuItem {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n.settingsMenuItem input {\n    margin-top: 2px;\n    background: var(--white);\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    outline: none;\n    border: none !important;\n    cursor: pointer;\n    width: 25px;\n}\n\n.settingsMenuItem label {\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    cursor: pointer;\n}\n\n.removeItemBtn {\n    background: none;\n    border: none;\n    padding: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    opacity: 0.6;\n    transition: opacity 0.2s;\n}\n\n.removeItemBtn:hover {\n    opacity: 1;\n}\n\n.removeItemBtn img {\n    width: 16px;\n    height: 16px;\n}\n\n.nothingFound {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    margin-bottom: 10px;\n}\n\n.showMorePages {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n    opacity: 0.5;\n    cursor: pointer;\n}\n\n.navigationRight {\n    margin-left: 35px;\n    padding-top: 0;\n    min-width: 300px;\n}\n\n.navRightList {\n    margin-top: 15px;\n}\n\n.menuSorter {\n    min-height: 200px;\n    position: relative;\n}\n\n.menuItemRow {\n    margin-bottom: 10px;\n}\n\n.menuItemRow.hidden {\n    opacity: 0.5;\n}\n\n.menuItem {\n    display: flex;\n    align-items: center;\n    padding: 11.5px 14px;\n    gap: 8px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    box-shadow: var(--boxshadow);\n    border-radius: 6px;\n    width: 100%;\n    cursor: grab;\n    font-size: 14px;\n    transition: all 0.2s ease;\n}\n\n.menuItem:active {\n    cursor: grabbing;\n}\n\n.dragIcon {\n    cursor: grab;\n    font-size: 16px;\n    color: var(--cloudburst);\n    opacity: 0.5;\n}\n\n.dragIcon:active {\n    cursor: grabbing;\n}\n\n.menuTitleFront {\n    flex: 1;\n    line-height: 18px;\n    position: relative;\n    top: 0px;\n}\n\n.placeholder {\n    background: var(--whitesmoke);\n    border: 1px dashed #d0d5dd;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    transition: all 0.2s ease;\n}\n\n.dragPreview {\n    position: absolute;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    pointer-events: none;\n}\n\n.dragPreviewItem {\n    display: flex;\n    align-items: center;\n    padding: 11.5px 14px;\n    gap: 8px;\n    background: var(--white);\n    border: 1px dashed #999;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.dragPreviewItemTitle {\n    flex: 1;\n    line-height: 18px;\n}\n\n.saveButtons {\n    display: flex;\n    justify-content: flex-end;\n    margin-block: 20px;\n    padding-top: 20px;\n    gap: 10px;\n    border-top: 1px solid #d4d4d4;\n}\n\n.saveButton {\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 22px;\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap;\n    background-color: #000;\n    border-color: transparent;\n    padding: 8px 13px;\n    text-align: center;\n    width: 66px;\n    height: 42px;\n}\n\n.saveButton:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.ringLoader {\n    width: 20px;\n    height: 20px;\n    border: 2px solid rgba(0, 0, 0, 0.1);\n    border-top-color: var(--cloudburst);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin: 0 auto;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n    .settingsListWrap {\n        flex-direction: column;\n    }\n\n    .navLeftList,\n    .navigationRight {\n        max-width: 100%;\n        min-width: auto;\n    }\n\n    .navigationRight {\n        margin-left: 0;\n        margin-top: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsMenuList": `page_settingsMenuList__a7m6T`,
	"settingsListWrap": `page_settingsListWrap__ajFRR`,
	"navLeftList": `page_navLeftList__oOYkY`,
	"settingsMenuBlockTitle": `page_settingsMenuBlockTitle__ePcZp`,
	"titleBottom": `page_titleBottom__ZSzau`,
	"navigationLeft": `page_navigationLeft__Vv-+V`,
	"navigationBlocks": `page_navigationBlocks__sV4ol`,
	"pagesTitle": `page_pagesTitle__1OLzl`,
	"active": `page_active__uO7B2`,
	"navigationTop": `page_navigationTop__8IglY`,
	"pageSearchInput": `page_pageSearchInput__+LKuJ`,
	"settingsMenuPages": `page_settingsMenuPages__x0xMi`,
	"settingsMenuItem": `page_settingsMenuItem__hvWtz`,
	"removeItemBtn": `page_removeItemBtn__IISeA`,
	"nothingFound": `page_nothingFound__FI5Mc`,
	"showMorePages": `page_showMorePages__zaMsn`,
	"navigationRight": `page_navigationRight__eplUk`,
	"navRightList": `page_navRightList__+trVx`,
	"menuSorter": `page_menuSorter__bkNTq`,
	"menuItemRow": `page_menuItemRow__GqFn0`,
	"hidden": `page_hidden__78hjc`,
	"menuItem": `page_menuItem__DYlEl`,
	"dragIcon": `page_dragIcon__lIVzV`,
	"menuTitleFront": `page_menuTitleFront__ppNx5`,
	"placeholder": `page_placeholder__2TdDV`,
	"dragPreview": `page_dragPreview__mTn3v`,
	"dragPreviewItem": `page_dragPreviewItem__j88LU`,
	"dragPreviewItemTitle": `page_dragPreviewItemTitle__kUsq6`,
	"saveButtons": `page_saveButtons__xbG0q`,
	"saveButton": `page_saveButton__hjObx`,
	"ringLoader": `page_ringLoader__YHdmS`,
	"spin": `page_spin__JeqAF`
};
export default ___CSS_LOADER_EXPORT___;
